'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
/**
 * @fileoverview 兼容参数
 */
// 兼容props，因为有些名称被废弃了但是要兼容
exports.default = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _extends({}, props, {
        open: typeof props.isOpen !== 'undefined' ? props.isOpen || false : props.open || false,
        onOpen: typeof props.onClickCollapseButton !== 'undefined' ? props.onClickCollapseButton : props.onOpen
    });
};